import { getEmailTemplatesService, getMonitoringLoggerService, getTemplatesService } from '@/core/container/ioc'
import { TmApiRetryAfterError } from '@/core/error/transport/tmApiRetryAfterError'
import { TmLostConnectionError } from '@/core/error/transport/tmLostConnectionError'
import { TmApiServerError } from '@/core/error/transport/tmApiServerError'
import { LogLevel } from '@/core/logger/types'

const handleTemplateUsageError = (e: unknown) => {
  if (e instanceof TmApiRetryAfterError || e instanceof TmLostConnectionError || e instanceof TmApiServerError) {
    return
  }

  const error = e instanceof Error ? e : new Error(`Template usage tracking failed: ${String(e)}`)
  getMonitoringLoggerService().logAndCapture(error, LogLevel.WARNING, 'template-usage-tracking')
}

export const useTrackSmsTemplateUsage = () => {
  const templatesService = getTemplatesService()

  const trackSmsTemplateUsage = (templateId: string) => {
    templatesService.markTemplateAsUsed(templateId).catch(handleTemplateUsageError)
  }

  return {
    trackSmsTemplateUsage,
  }
}

export const useTrackEmailTemplateUsage = () => {
  const emailTemplatesService = getEmailTemplatesService()

  const trackEmailTemplateUsage = (templateId: string) => {
    emailTemplatesService.markTemplateAsUsed(templateId).catch(handleTemplateUsageError)
  }

  return {
    trackEmailTemplateUsage,
  }
}
